//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import VisualDesign from '@/../lib/visual-design/designer.umd.js'
import ReferenceSearchTable from '@/components/mlReferenceSearch/reference-search-table.vue';
// import emitter from '@/utils/emitter'
// const { FormItemWrapper, emitter, i18n, fieldMixin } = VisualDesign.VFormSDK
import FormItemWrapper from './form-item-wrapper';
import emitter from '@/utils/emitter';
import i18n, { translate } from '@/utils/i18n';
import fieldMixin from '@/components/form-designer/form-widget/field-widget/fieldMixin';
export default {
  name: 'input-select-widget',
  componentName: 'FieldWidget',
  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,
    designState: {
      type: Boolean,
      default: false
    },
    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */type: Number,
      default: -1
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */type: String,
      default: ''
    }
  },
  components: {
    FormItemWrapper: FormItemWrapper,
    ReferenceSearchTable: ReferenceSearchTable,
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectOne: function selectOne() {
      return import('@/components/form-common/select-one');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    }
  },
  data: function data() {
    return {
      oldFieldValue: null,
      //field组件change之前的值
      fieldModel: null,
      displayValue: '',
      rules: [],
      name: 'selectMember',
      showReferenceDialogFlag: false,
      entity: null,
      curRefField: null,
      searchFilter: ''
    };
  },
  computed: {
    inputType: function inputType() {
      if (this.field.options.type === 'number') {
        return 'text'; //当input的type设置为number时，如果输入非数字字符，则v-model拿到的值为空字符串，无法实现输入校验！故屏蔽之！！
      }
      return this.field.options.type;
    },
    contentForReadMode: function contentForReadMode() {
      return this.fieldModel ? this.fieldModel.name : '--';
    },
    dialogWidth: function dialogWidth() {
      return this.field.options.searchDialogWidth || '520px';
    }
  },
  watch: {
    fieldModel: {
      deep: true,
      immediate: true,
      handler: function handler(val) {
        this.displayValue = !!val ? val.name : '';
      }
    }
  },
  beforeCreate: function beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },
  created: function created() {
    var gDsv = this.getGlobalDsv();
    this.entity = gDsv['formEntity'] || this.$route.query.entity || this.$route.meta.entityName;
    if (!!this.subFormItemFlag) {
      //设置为明细实体名称！！
      this.entity = this.subFormName;
    }

    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
     需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initFieldModel();
    this.initEventHandler();
    this.buildFieldRules();
    this.handleOnCreated();
  },
  mounted: function mounted() {
    this.handleOnMounted();
  },
  beforeUnmount: function beforeUnmount() {
    this.unregisterFromRefList();
  },
  methods: {
    onAppendButtonClick: function onAppendButtonClick() {
      var _this = this;
      if (['user_id', 'update_user_id', 'owner_user_id'].includes(this.field.options.formFieldUniqid)) {
        this.name = 'selectMember';
        this.$refs.selectMember.handlePopoverShow();
      } else if (['frame_id'].includes(this.field.options.formFieldUniqid)) {
        this.name = 'selectDepartment';
        setTimeout(function () {
          _this.$refs.selectMember.handlePopoverShow();
        }, 300);
      } else {
        this.name = 'selectOne';
        setTimeout(function () {
          _this.$refs.selectMember.handlePopoverShow();
        }, 300);
      }
    },
    handleClearEvent: function handleClearEvent() {
      this.fieldModel = {};
      this.handleChangeEvent(this.fieldModel);
    },
    setReferRecord: function setReferRecord(recordObj, selectedRow) {
      this.fieldModel = {
        id: recordObj[0].id,
        name: recordObj[0].label
      };
      this.handleChangeEvent(this.fieldModel);
      this.handleRecordSelectedEvent(selectedRow);
    },
    getSelectList: function getSelectList(recordObj) {
      this.fieldModel = {
        id: recordObj[0].value,
        name: recordObj[0].name
      };
      this.handleChangeEvent(this.fieldModel);
    },
    getSelection: function getSelection(data) {
      this.fieldModel = {
        id: data.id,
        name: data.name
      };
      this.handleChangeEvent(this.fieldModel);
    },
    setFilter: function setFilter(newFilter) {
      this.searchFilter = newFilter;
    },
    handleRecordSelectedEvent: function handleRecordSelectedEvent(selectedRow) {
      if (!!this.designState) {
        //设计状态不触发事件
        return;
      }
      if (!!this.field.options.onRecordSelected) {
        var customFn = new Function('selectedRow', this.field.options.onRecordSelected);
        customFn.call(this, selectedRow);
      }
    }
  }
};